import { toPrecision, scientificNotationToString } from '../utils/numbers';
import { TokenMetadata } from './ft-contract';

export interface PoolRPCView {
  id: number;
  token_account_ids: string[];
  token_symbols: string[];
  amounts: string[];
  pool_kind?: string;
  total_fee: number;
  shares_total_supply: string;
  tvl: number;
  token0_ref_price: string;
  share: string;
  decimalsHandled?: boolean;
  tokens_meta_data?: TokenMetadata[];
  h24volume?: string;
  apr?: number;
  baseApr?: string;
}

export const parsePoolView = (pool: any): PoolRPCView => ({
  id: Number(pool.id),
  token_account_ids: pool.token_account_ids,
  token_symbols: pool.token_symbols,
  amounts: pool.amounts,
  total_fee: pool.total_fee,
  shares_total_supply: pool.shares_total_supply,
  tvl: Number(
    toPrecision(
      scientificNotationToString(pool?.tvl?.toString() || '0'),
      2,
      false,
      false
    )
  ),
  token0_ref_price: pool.token0_ref_price,
  share: pool.share,
});

// Geo-restriction check. Expects `{ "blocked": boolean }`. Off unless
// REACT_APP_GEO_BLOCK_URL is set (upstream used https://geo.deltarpc.com/api/is-blocked).
export const GEO_BLOCK_URL = (process.env.REACT_APP_GEO_BLOCK_URL || '').trim();

export const getUserIsBlocked = async (): Promise<any> => {
  return await fetch(GEO_BLOCK_URL, {
    method: 'GET',
    headers: { 'Content-type': 'application/json; charset=UTF-8' },
  }).then((response) => response.json());
};
